import { SDK_INIT_OPTIONS } from "../constants/sdk";

export const loadSDK = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.nbc?.identity) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = "https://id.nbcuni.com/websdk/v2/identity-sdk.min.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load NBC Identity SDK"));
    document.body.appendChild(script);
  });
};

export const initializeSDK = async (
  clientId: string,
  initOptions: any,
  handleSdkStatusChange?: (...args: any[]) => void,
  handleAuthenticationStateChange?: (...args: any[]) => void
) => {
  await loadSDK();
  if (window.nbc?.identity) {
    await window.nbc.identity.initialize(clientId, initOptions);
    if (handleSdkStatusChange) {
      window.nbc.identity.on("status", handleSdkStatusChange);
    }
    if (handleAuthenticationStateChange) {
      window.nbc.identity.on("authenticationState", handleAuthenticationStateChange);
    }
  } else {
    throw new Error("NBC Identity SDK not available after loading.");
  }
};
